import { FEEDBACK, SUPPORT_ITEMS } from '@mm/api-routes';
import {
  SupportItemsListModel,
  SupportSectionTypes,
} from '../model/SupportItemModel';
import AuthenticatedController from './AuthenticatedController';

export default class SupportItemController extends AuthenticatedController {
  static async retrieveAll(
    section: SupportSectionTypes,
    pageNumber = 0,
    pageSize = 10,
  ): Promise<SupportItemsListModel> {
    return super.get(SUPPORT_ITEMS, {
      section,
      page: pageNumber,
      perPage: pageSize,
    });
  }

  static async publish(
    email: string,
    comment: string,
    name: string,
    assetId?: number | null,
  ) {
    return super.post(FEEDBACK, {
      email,
      comment,
      name,
      assetId,
      platform: 'desktop',
    });
  }
}
